import React, { useState } from 'react';
import Styles from './CheckBoxPolicy.scss';
import { Checkbox, Link } from '@npm-registry/eapteka-ui';
import {
  COMPANY_CONTRACT,
  COMPANY_PERSONAL_DATA_POLICY,
  COMPANY_POLICY,
  SUBSCRIPTION_LANDING
} from '../../../config';

const LinkCompanyContract = () => {
  return (
    <Link href={COMPANY_CONTRACT} target="_blank">
      пользовательским соглашением
    </Link>
  );
};
const LinkPolicy = () => {
  return (
    <Link href={COMPANY_POLICY} target="_blank">
      политикой конфиденциальности
    </Link>
  );
};
const LinkPersonalDataPolicy = () => {
  return (
    <Link
      href={COMPANY_PERSONAL_DATA_POLICY}
      target="_blank"
    >
      политикой в отношении обработки персональных данных
    </Link>
  );
};
const LinkAcceptSpam = () => {
  return (
    <Link href={SUBSCRIPTION_LANDING} target="_blank">
      согласие
    </Link>
  );
};

const CheckBoxPolicy = () => {
  const [policyCheckbox, setPolicyCheckbox] =
    useState(false);
  const [subscriptionsCheckbox, setSubscriptionsCheckbox] =
    useState(true);

  const toggleCheckMarkPolicy = () => {
    setPolicyCheckbox((prev) => !prev);
  };
  const toggleCheckMarkSubscription = () => {
    setSubscriptionsCheckbox((prev) => !prev);
  };

  return (
    <>
      <div className={Styles.checkboxItem}>
        <Checkbox
          onChange={toggleCheckMarkPolicy}
          checked={policyCheckbox}
        />
        Даю согласие на обработку персональных данных в
        соответствии с <LinkPersonalDataPolicy />,{' '}
        <LinkPolicy />, соглашаюсь с <LinkCompanyContract />
      </div>
      <div className={Styles.checkboxItem}>
        <Checkbox
          onChange={toggleCheckMarkSubscription}
          checked={subscriptionsCheckbox}
        />
        Предоставляю <LinkAcceptSpam /> на получение
        рекламных новостей, акций и персональных предложений
      </div>
    </>
  );
};

export default CheckBoxPolicy;
